import { useCallback, useEffect, useState } from 'react';
import { coachDashboard, type CoachDashboardOverview } from '../services/api';

export function useCoachDashboardOverview(refreshKey: number) {
  const [data, setData] = useState<CoachDashboardOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await coachDashboard.getOverview();
      setData(response.data?.data ?? null);
    } catch {
      setData(null);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [refreshKey, reload]);

  return { data, loading, error, reload };
}
